import React from 'react';
import { Link } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';
import './CreditsDisplay.css';

interface CreditsDisplayProps {
  variant?: 'sidebar' | 'header' | 'inline';
  onClick?: () => void;
}

const CreditsDisplay: React.FC<CreditsDisplayProps> = ({ 
  variant = 'inline', 
  onClick 
}) => {
  const { user } = useUser();

  if (user?.credits === undefined) {
    return null;
  }

  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  const renderCredits = () => (
    <>
      <span className="credits-icon">💎</span>
      <span className="credits-text">
        {user.credits} credits available
      </span>
    </>
  );

  switch (variant) {
    case 'sidebar':
      return (
        <div className="credits-display sidebar-credits">
          <Link to="/buy-credits" className="credits-button sidebar-credits-button" onClick={handleClick}>
            {renderCredits()}
          </Link>
        </div>
      );
    
    case 'header':
      return (
        <div className="credits-display header-credits">
          <Link to="/buy-credits" className="credits-link" onClick={handleClick}>
            <div className="credits-card">
              {renderCredits()}
            </div>
          </Link>
        </div>
      );
    
    default:
      return (
        <div className="credits-display inline-credits">
          <Link to="/buy-credits" className="credits-link" onClick={handleClick}>
            <div className="credits-card">
              {renderCredits()}
            </div>
          </Link>
        </div>
      );
  }
};

export default CreditsDisplay;
